var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("bimini-default-section", {
    staticClass: "menu--section-bimini_dessert",
    attrs: {
      menu: _vm.menu,
      section: _vm.section,
      "menu-item-tag-location": "before-title",
      "is-title-buffer-visible": "",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }